export function ProfileAccessSkeleton() {
  const renderSkeletonApplication = () => (
    <div className="flex flex-col gap-2 animate-pulse">
      <div className="h-5 bg-base-200 rounded w-48" />
      <div className="bg-neutral-50 rounded-xl p-4">
        <div className="space-y-3">
          {[...Array(2)].map((_, rowIndex) => (
            <div
              key={rowIndex}
              className="flex items-center justify-between p-3 bg-white rounded"
            >
              <div className="flex items-center gap-4">
                <div className="space-y-2">
                  <div className="h-4 bg-base-200 rounded w-32" />
                  <div className="flex gap-2">
                    <div className="h-6 bg-base-200 rounded w-16" />
                    <div className="h-6 bg-base-200 rounded w-20" />
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-6 bg-base-200 rounded w-12" />
                <div className="flex gap-1">
                  <div className="w-7 h-7 bg-base-200 rounded" />
                  <div className="w-7 h-7 bg-base-200 rounded" />
                  <div className="w-7 h-7 bg-base-200 rounded" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )

  return (
    <div className="space-y-6">
      {[...Array(2)].map((_, index) => (
        <div key={index}>{renderSkeletonApplication()}</div>
      ))}
    </div>
  )
}
